"use client";

import { c as _c } from "react/compiler-runtime";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import "swiper/css";
import "swiper/css/autoplay";
import { aboutGalleryData } from "@/data/FeatureGalleryData";
const CurvedSlider = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [Autoplay];
    t1 = {
      delay: 0,
      disableOnInteraction: false
    };
    t2 = {
      640: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      },
      1280: {
        slidesPerView: 4
      }
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="about-gallery-wrapper"><Swiper spaceBetween={12} slidesPerView={2} loop={true} speed={5000} modules={t0} autoplay={t1} breakpoints={t2} allowTouchMove={false} className="curved-gallery-swiper">{aboutGalleryData.map(_temp)}</Swiper></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default CurvedSlider;
function _temp(img, index) {
  return <SwiperSlide key={index}><div className="gallery-image-container"><Image src={img.src} alt={img.alt || "Octarnal project gallery image"} fill={true} className="object-cover" sizes="(max-width: 768px) 300px, 600px" /></div></SwiperSlide>;
}